var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _ellipse2, _path8, _ellipse3, _circle, _path9, _path0, _path1, _circle2, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-7.5L37 53l20-2V36z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35 35h31v23H35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63.5V41l-8 12-.5 4.5 8.5 6z",
    fill: "#E1F8F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35v23l-3-1M35.78 30H27l8 5h32l-9-5H40.17M76 41v23l-10-6V35h10v3",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52.068c0 .999-4.253 1.81-9.5 1.81s-9.5-.811-9.5-1.81v-2.715c2.018 0 17.461-.204 19 0v2.715z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5,
    cy: 49.353,
    rx: 9.5,
    ry: 1.81,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h3.5M57 35.5V45M63 55l2.5 2",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.226 65.927c0 1.23-5.234 2.227-11.691 2.227-6.458 0-11.692-.997-11.692-2.227v-3.34c2.484 0 21.49-.252 23.383 0v3.34z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.535,
    cy: 62.587,
    rx: 11.692,
    ry: 2.227,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.226 58.74c0 1.23-5.234 2.227-11.691 2.227-6.458 0-11.692-.997-11.692-2.227V55.4c2.484 0 21.49-.252 23.383 0v3.34z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.535,
    cy: 55.4,
    rx: 11.692,
    ry: 2.227,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.552,
    cy: 37.405,
    r: 6.564,
    transform: "rotate(-18.398 18.552 37.405)",
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.034 39.243a.96.96 0 00-.02 1.921l.02-1.921zm1.196.775l-.298-.913-.004.001.302.912zm1.035-1.398l.95-.144-.95.144zm-.769-.962l.349-.895-.003-.001-.346.896zm-1.234.02l.127.952.007-.001-.134-.952zm-1.016-.141l-.51.814.005.004.505-.818zm-.571-.861l-.95.144v.005l.95-.149zm1.034-1.399l.3.913-.3-.913zm1.174.776a.961.961 0 00.065-1.921l-.065 1.92zm-.86 4.15l-.009.961h.048c.026 0 .06 0 .103-.002.084-.003.2-.01.338-.023a4.815 4.815 0 001.03-.209l-.605-1.824c-.196.065-.42.102-.61.12a3.619 3.619 0 01-.276.017h-.011.002l-.01.96zm1.506.729a2.662 2.662 0 001.212-.82c.334-.406.573-.976.474-1.636l-1.9.287c0 .01.008.047-.057.127a.743.743 0 01-.326.215l.597 1.827zm1.686-2.456a2.198 2.198 0 00-1.37-1.713l-.697 1.79a.276.276 0 01.166.21l1.9-.287zm-1.373-1.714a2.329 2.329 0 00-1.036-.13c-.241.019-.562.077-.678.093l.268 1.904c.11-.016.24-.038.324-.051.096-.015.172-.026.24-.031a.475.475 0 01.19.008l.692-1.793zm-1.706-.038a1.365 1.365 0 01-.301.015c-.062-.006-.081-.018-.084-.02l-1.01 1.636c.606.373 1.258.326 1.648.275l-.253-1.906zm-.38-.001a.305.305 0 01-.132-.197l-1.898.3c.099.629.477 1.19 1.01 1.525l1.02-1.628zm-.131-.19a.278.278 0 01-.001-.104.078.078 0 01.016-.032c.023-.032.114-.123.37-.207l-.601-1.826c-.495.163-.972.436-1.303.874-.348.461-.467 1.016-.381 1.582l1.9-.288zm.385-.343a2.888 2.888 0 01.824-.137H18.883l.033-.96.032-.961h-.001-.017l-.033-.001h-.102a4.81 4.81 0 00-1.386.233l.6 1.826z",
    fill: "#7E776E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.506 40.361l.35 1.054M17.314 33.74l.34 1.027",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31 39.084L17.05 53 3 39.084h6.313v-7.366M24.84 13.562V26.5M9.313 13.562V11",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 22.5,
    r: 6.5,
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20l-5 5M10.5 21a.5.5 0 100-1 .5.5 0 000 1zM14.5 25a.5.5 0 100-1 .5.5 0 000 1z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgOffset;